import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiButton from "../General/SteddiButton";
import * as React from "react";
import {useEffect, useState} from "react";
import {Box} from "@mui/material";
import PageHeader from "../General/PageHeader";
import SignSteps from "../General/SignSteps";
import NiceModal from "@ebay/nice-modal-react";
import CancelDialog from "../Esign/Steps/CancelDialog";
import {getEKInfo, startCancelProcess} from "../../api/SignRequests";
import {parseEndpointError} from "../../helpers/orderHelpers";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import useErrorStore from "../../stores/errorStore";
import InitialCancelPage from "./Steps/InitialCancelPage";
import useOrderState from "../../stores/orderStore";
import {ReactComponent as SteddiGraph} from "../../images/Forutsigbar Betaling.svg"
import {ReactComponent as Calculator} from "../../images/Reberegning.svg"
import CancelSaldo from "./Steps/CancelSaldo";
import LoadingPage from "../Esign/Steps/LoadingPage";
import useAppState from "../../stores/appStateStore";
import BrandEnum from "../../types/BrandEnum";
import enumFromName from "../../helpers/BrandParser";

export default function CancelWrapper() {
  let {hashId} = useParams<string>()
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate()

  const orderState = useOrderState((state) => state)
  const setRedirectBrand = useAppState((state) => state.setRedirectBrand)
  const setError = useErrorStore((state) => state.setError)
  const error = useErrorStore((state) => state.error)

  const [activeStep, setActiveStep] = React.useState(0);
  const [cancelProcessStarted, setCancelProcessStarted] = React.useState(false);
  const [orderLoading, setOrderLoading] = useState(true)

  function handleCancel() {
    NiceModal.show(CancelDialog)
  }

  useEffect(() => {
    document.title = "Steddi - Avbestill"
  }, [])

  useEffect(() => {
    if (hashId) {
      setOrderLoading(true)
      getEKInfo(hashId!)
        .then(account => {
          orderState.setAccount(account)
        })
        .catch(err => {
          setError(parseEndpointError(err))
        })
        .finally(() => setOrderLoading(false))
    }
  }, [hashId])

  useEffect(() => {
    try {
      const brandString = searchParams.get("brand")
      if(brandString != null) {
        const brand = enumFromName(brandString, BrandEnum)
        setRedirectBrand(brand)
      }
    } catch(e){
      console.log("Could not parse brand")
      console.log(e)
      setRedirectBrand(BrandEnum.Unknown)
    }
  }, [searchParams])

  function handleCancelSteddi() {
    if (hashId) {
      setCancelProcessStarted(true)

      startCancelProcess(hashId)
        .then(() => {
          navigate("completed")
        }).catch(err => {
        setError(parseEndpointError(err))
      })
    }
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    window.scrollTo({ top: 0, left: 0 });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    window.scrollTo({ top: 0, left: 0 });
  };

  const steps = [
    {title: "Avbestill Forutsigbar Betaling", element: <InitialCancelPage/>, image: <SteddiGraph/>},
    {title: "Saldo og opphørsfaktura", element: <CancelSaldo/>, image: <Calculator/>},
  ]

  useEffect(() => {
    if (error)
      navigate("error")
  }, [error])

  function getStepButtons() {
    return (
      <Grid2 container mt={5} spacing={2} justifyContent="space-between">
        <Grid2 xs={12} sm={"auto"} hidden={activeStep > 0}></Grid2>
        <Grid2 xs={12} sm={"auto"} hidden={activeStep === 0}>
          <SteddiButton onClick={handleBack} color="secondary" disabled={cancelProcessStarted}>Forrige</SteddiButton>
        </Grid2>

        <Grid2 xs={12} sm={"auto"} container spacing={2} justifyContent="flex-end">
          <Grid2 xs={12} sm="auto" hidden={activeStep === 0} sx={{display: {xs: "none", sm: "block"}}}>
            <SteddiButton variant="outlined" onClick={handleCancel} disabled={cancelProcessStarted}>Avbryt</SteddiButton>
          </Grid2>
          <Grid2 xs={12} sm="auto">
            {activeStep === steps.length - 1 ?
              <SteddiButton onClick={handleCancelSteddi} disabled={cancelProcessStarted} loading={cancelProcessStarted}>Bekreft avbestilling</SteddiButton> :
              <SteddiButton onClick={handleNext} disabled={cancelProcessStarted}>Gå videre</SteddiButton>}
          </Grid2>
        </Grid2>
      </Grid2>
    )
  }

  if (orderLoading) {
    return (
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <LoadingPage/>
      </Box>
    )
  }

  return (
    <>
      <Box pt={5}>
        <Box display="flex" justifyContent="flex-end">
          <SteddiButton variant="text" onClick={handleCancel} onlyShowXs noShrink sx={{mb: 3}} disabled={cancelProcessStarted}>Avbryt</SteddiButton>
        </Box>
        {steps[activeStep].image && <Box display="flex" alignItems="center" justifyContent="center" mb={5}>{steps[activeStep].image}</Box>}
        <PageHeader>{steps[activeStep].title}</PageHeader>
        <SignSteps showOnFirst activeStep={activeStep + 1} amountOfSteps={steps.length + 1}/>
        {steps[activeStep].element}
      </Box>
      {getStepButtons()}
    </>
  )
}